/**
 * Oberflächentexte (nur Deutsch, Entscheidung Flori 23.10.2026) und Formatierung.
 * Texte stehen zentral, damit Zustände aus der API (Jobtypen, Fehlercodes) einheitlich
 * beschriftet werden.
 */
const TEXTS = {
  'app.name': 'Premium Auction Tools',
  'nav.start': 'Start',
  'nav.items': 'Angebote',
  'nav.galleries': 'Cross-Selling',
  'nav.articles': 'Artikel',
  'nav.designs': 'Designs',
  'nav.media': 'Medien',
  'nav.account': 'Konto',
  'nav.ebay': 'eBay & Live-Update',
  'ebayInterface.title': 'eBay & Live-Update',
  'liveUpdate.title': 'Live-Update',
  'liveUpdate.intro': 'Cross-Selling braucht Live-Update: Nur mit eingeschaltetem Live-Update bringt PAT Ihre Galerien in die eBay-Beschreibungen und hält die Angebote darin aktuell. Ohne Live-Update ist Cross-Selling nur eingeschränkt nutzbar. Ohne Ihre Zustimmung schreibt PAT nichts in Ihre Beschreibungen.',
  'liveUpdate.tokenRequired': 'Einschalten geht erst wieder mit gültiger eBay-Verbindung. Bitte zuerst „eBay neu verbinden“; danach schalten Sie Live-Update hier wieder ein.',
  'liveUpdate.switch.on': 'Live-Update ist eingeschaltet',
  'liveUpdate.switch.off': 'Live-Update ist ausgeschaltet',
  'liveUpdate.badge.on': 'An',
  'liveUpdate.badge.off': 'Aus',
  'liveUpdate.on': 'Seit {date}. Galerieblöcke werden automatisch aufgefrischt (alle {days} Tage).',
  'liveUpdate.off': 'PAT verändert keine Beschreibungen bei eBay.',
  'liveUpdate.notAllowed': 'Live-Update ist im Tarif dieses Kontos nicht enthalten.',
  'liveUpdate.notMigrated': 'Bis zum Abschluss des Umzugs gilt Ihre Einstellung aus dem bisherigen PAT.',
  'liveUpdate.onWithoutRight': 'Im Tarif dieses Kontos nicht enthalten; PAT ändert keine Beschreibungen bei eBay.',
  'liveUpdate.ownerOnly': 'Ein- und ausschalten kann nur der Inhaber des Kontos.',
  'liveUpdate.rules': 'PAT schreibt automatisch nur Galerieblöcke (zwischen den PAT-Markierungen). Vollständige Artikelbeschreibungen ersetzt PAT nur, wenn Sie das je Angebot beim Artikel ausdrücklich beauftragen. Vor jedem Schreiben sichert PAT die bisherige Beschreibung.',
  'liveUpdate.changed': 'Live-Update wurde umgeschaltet.',
  'liveUpdate.item.title': 'eBay-Angebote updaten',
  'liveUpdate.item.intro': 'Geben Sie eine oder mehrere eBay-Artikelnummern ein, um für diese Angebote das Live-Update zu starten.',
  'liveUpdate.item.label': 'eBay-Artikelnummern',
  'liveUpdate.item.hint': 'Getrennt durch Zeilen, Leerzeichen, Komma oder Semikolon; eBay-Links gehen auch. Höchstens 50 auf einmal.',
  'liveUpdate.item.preview': 'Erkannte Artikelnummern',
  'liveUpdate.item.found': '{count} Artikelnummern erkannt.',
  'liveUpdate.item.found.one': '1 Artikelnummer erkannt.',
  'liveUpdate.item.duplicates': 'Doppelte nur einmal übernommen ({count}).',
  'liveUpdate.item.invalid': 'Nicht erkannt und ignoriert: {list}',
  'liveUpdate.item.tooMany': 'Höchstens {max} Artikelnummern auf einmal; bitte aufteilen.',
  'liveUpdate.item.submit': 'Live-Update starten',
  'liveUpdate.item.submit.many': 'Live-Update für {count} Angebote starten',
  'liveUpdate.item.done': '{queued} von {count} Angeboten stehen in der Warteschlange für das Live-Update.',
  'liveUpdate.item.results': 'Ergebnis je Angebot',
  'liveUpdate.item.outcome.queued': 'In der Warteschlange',
  'liveUpdate.item.outcome.not-found': 'In diesem Konto nicht gefunden',
  'liveUpdate.item.outcome.item-ended': 'Beendet, kein Update',
  'liveUpdate.item.outcome.ambiguous': 'Mehrfach vorhanden, nicht übernommen',
  'liveUpdate.item.off': 'Das geht, sobald Live-Update eingeschaltet ist.',
  'nav.logout': 'Abmelden',
  'nav.tenant': 'Konto wechseln',
  'nav.menu': 'Menü öffnen oder schließen',
  'login.title': 'Anmelden',
  'login.email': 'E-Mail-Adresse',
  'login.password': 'Passwort',
  'login.submit': 'Anmelden',
  'login.forgot': 'Passwort vergessen?',
  'login.hint': 'Melden Sie sich mit Ihrer bisherigen PAT-E-Mail-Adresse und Ihrem bisherigen Passwort an.',
  'login.devHint': 'Entwicklungsmodus: Anmeldung ohne Cognito gegen den lokalen API-Server.',
  'login.resetPendingHint': 'Haben Sie „Passwort vergessen“ angefordert? Dann gilt das alte Passwort nicht mehr; bitte schließen Sie den Vorgang mit dem Code aus der E-Mail ab.',
  'forgot.title': 'Passwort zurücksetzen',
  'forgot.request': 'Code anfordern',
  'forgot.sent': 'Falls ein Konto existiert, haben wir einen Code an die E-Mail-Adresse gesendet.',
  'forgot.code': 'Code aus der E-Mail',
  'forgot.newPassword': 'Neues Passwort',
  'forgot.confirm': 'Passwort speichern',
  'forgot.done': 'Passwort geändert. Bitte melden Sie sich an.',
  'forgot.resetRequired': 'Für Ihr Konto muss ein neues Passwort vergeben werden (mindestens 8 Zeichen).',
  'auth.error.invalid-credentials': 'E-Mail-Adresse oder Passwort falsch.',
  'auth.error.reset-required': 'Bitte setzen Sie Ihr Passwort zurück.',
  'auth.error.not-confirmed': 'Das Konto ist noch nicht bestätigt.',
  'auth.error.invalid-code': 'Der Code ist falsch oder abgelaufen.',
  'auth.error.weak-password': 'Das Passwort erfüllt die Anforderungen nicht (mindestens 8 Zeichen).',
  'auth.error.rate-limited': 'Zu viele Versuche. Bitte warten Sie einige Minuten.',
  'auth.error.unsupported-challenge': 'Diese Anmeldung erfordert einen Schritt, den die App noch nicht unterstützt.',
  'auth.error.network': 'Keine Verbindung. Bitte später erneut versuchen.',
  'auth.error.unknown': 'Anmeldung fehlgeschlagen.',
  'common.loading': 'Wird geladen …',
  'common.back': 'Zurück',
  'common.error': 'Daten konnten nicht geladen werden.',
  'common.forbidden': 'Kein Zugriff auf dieses Konto.',
  'common.retry': 'Erneut versuchen',
  'common.never': 'noch nie',
  'common.unknown': '–',
  'common.yes': 'ja',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.close': 'Schließen',
  'common.saveFailed': 'Speichern fehlgeschlagen.',
  'common.no': 'nein',
  'galleries.title': 'Cross-Selling-Galerien',
  'galleries.empty': 'Für dieses Konto sind keine Galerien angelegt.',
  'galleries.col.name': 'Name',
  'galleries.col.g': 'Galerie-Nr.',
  'galleries.col.link': 'Verlinkung',
  'galleries.col.state': 'Zustand',
  'galleries.locked': 'Regeln gesperrt',
  'galleries.link.all': 'Alle Angebote',
  'galleries.link.same-store-category': 'Gleiche Shopkategorie',
  'galleries.link.same-ebay-category': 'Gleiche eBay-Kategorie',
  'galleries.link.customCount': '{n} eigene Regeln',
  'galleries.settings': 'Einstellungen',
  'galleries.readOnlyHint': 'Bearbeiten ist mit Ihrer Rolle oder im aktuellen Umzugsstand nicht möglich.',
  'galleries.edit.settings': 'Einstellungen bearbeiten',
  'galleries.edit.rules': 'Regeln bearbeiten',
  'galleries.edit.renameWarning': 'Der Name steht im Einbettcode: Umbenennen aktualisiert die Beschreibungen aller Angebote mit dieser Galerie.',
  'galleries.edit.nameRequired': 'Bitte einen Namen angeben',
  'galleries.delete': 'Galerie löschen',
  'galleries.delete.title': 'Galerie löschen',
  'galleries.delete.text': '„{name}“ wird gelöscht. Das lässt sich nicht rückgängig machen; als Ersatz legen Sie eine neue Galerie an (sie bekommt eine neue Nummer).',
  'galleries.delete.removes': 'PAT entfernt den Galerieblock nach und nach aus den Beschreibungen, in denen PAT diese Galerie pflegt. Bis dahin und überall sonst, wo er steht, erscheint an seiner Stelle eine leere Fläche.',
  'galleries.delete.keeps': 'PAT entfernt den Galerieblock derzeit nicht: {reason}. Wo er in Beschreibungen steht, erscheint an seiner Stelle eine leere Fläche.',
  'galleries.delete.fullMode': 'In vollständig von PAT geschriebenen Beschreibungen bleibt die Galeriebox mit ihrer Überschrift leer stehen, auch nach einem neuen Auftrag je Angebot. Entfernen lässt sie sich nur über eine neue Designfassung, neu veröffentlichte Artikel und je Angebot einen neuen Auftrag.',
  'galleries.delete.insert': 'Das automatische Einfügen dieser Galerie ({position}) endet.',
  'galleries.delete.insert.top': 'oben',
  'galleries.delete.insert.bottom': 'unten',
  'galleries.delete.designs': 'Betroffen: {designs} Design(s) mit {articles} Artikel(n). Dort bleibt die Galeriebox leer, bis Sie im Design eine andere Galerie wählen oder die Box entfernen und neu veröffentlichen.',
  'galleries.delete.confirm': 'Endgültig löschen',
  'galleries.delete.embeds': 'PAT hat diese Galerie zuletzt in {n} Angebot(e) geschrieben.',
  'galleries.delete.embedsPartial': 'Zählung nicht abgeschlossen: PAT hat diese Galerie zuletzt in mindestens {n} Angebot(e) geschrieben.',
  'galleries.delete.embedsUnknown': 'Ob und in wie vielen Angeboten diese Galerie steht, ließ sich gerade nicht ermitteln.',
  'galleries.delete.embedsUnresolved': 'Bei {n} Angebot(en) hat PAT die Beschreibung noch nicht selbst geschrieben; ob sie diese Galerie enthält, ist noch nicht bekannt.',
  'galleries.delete.embedsUnresolvedPartial': 'Bei mindestens {n} Angebot(en) hat PAT die Beschreibung noch nicht selbst geschrieben; ob sie diese Galerie enthält, ist noch nicht bekannt.',
  'galleries.items.title': 'Angebote mit dieser Galerie',
  'galleries.items.intro': 'Angebote, in die PAT diese Galerie zuletzt geschrieben hat. Bei Angeboten aus dem bisherigen PAT ist das erst nach dem ersten Abgleich bekannt.',
  'galleries.items.show': 'Anzeigen',
  'galleries.items.none': 'Keine Angebote bekannt, in die PAT diese Galerie geschrieben hat.',
  'galleries.items.more': 'Weitere laden',
  'galleries.items.searchOn': 'Weiter suchen',
  'galleries.items.searching': 'Noch nicht alle Angebote durchsucht.',
  'galleries.items.missing': 'nicht im Bestand',
  'galleries.items.mode.full': 'ganze Beschreibung',
  'galleries.items.mode.block': 'Galerieblock',
  'galleries.delete.usageFailed': 'Die Verwendung konnte nicht geladen werden; Löschen ist trotzdem möglich.',
  'galleries.delete.reason.queued': 'die Übertragung an eBay ist in dieser Umgebung noch nicht aktiv',
  'galleries.delete.reason.opt-in-off': 'Live-Update ist ausgeschaltet',
  'galleries.delete.reason.live-update-off': 'Live-Update ist im Tarif dieses Kontos nicht enthalten',
  'galleries.delete.reason.paused': 'der Abgleich ist pausiert',
  'galleries.delete.reason.ebay-disconnected': 'die eBay-Verbindung fehlt oder ist abgelaufen',
  'galleries.delete.reason.sync-incomplete': 'der erste vollständige Abgleich steht noch aus',
  'galleries.delete.reason.jobs-off': 'für dieses Konto laufen noch keine Abgleiche',
  'galleries.delete.reason.account-inactive': 'das Konto ist nicht aktiv',
  'galleries.delete.reason.other': 'Aktualisierungen sind für dieses Konto gerade gesperrt',
  'galleries.linkTarget': 'Link öffnet',
  'galleries.linkTarget._blank': 'in neuem Fenster',
  'galleries.linkTarget._self': 'im selben Fenster',
  'galleries.colors.own': 'Eigene Farben',
  'galleries.create.open': 'Neue Galerie',
  'galleries.create.title': 'Neue Galerie anlegen',
  'galleries.create.hint': 'Die Galerie erhält eine neue Nummer und zeigt zunächst alle Angebote der gewählten Site; Regeln legen Sie danach fest.',
  'galleries.create.submit': 'Anlegen',
  'galleries.rules.editTitle': 'Regeln bearbeiten',
  'galleries.rules.editHint': 'Regeln wirken nach Priorität (1 zuerst). Die Vorschau unten wertet den Entwurf aus, ohne zu speichern.',
  'galleries.rules.none': 'Keine eigenen Regeln: Die Galerie zeigt alle Angebote der Site.',
  'galleries.rules.add': 'Regel hinzufügen',
  'galleries.rules.remove': 'Entfernen',
  'galleries.rules.save': 'Regeln speichern',
  'galleries.rules.rowLabel': 'Regel {n}',
  'galleries.rules.source': 'Wenn das Angebot passt zu',
  'galleries.rules.target': 'dann zeige Angebote mit',
  'galleries.rules.all': 'Alle Angebote',
  'galleries.rules.searchPlaceholder': 'Eine Zeile je Alternative; Begriffe einer Zeile gelten zusammen, -wort schließt aus, "Wortfolge" in Anführungszeichen, nr:123… für bestimmte Angebote',
  'galleries.rules.categories': 'Kategorien',
  'galleries.rules.categoriesHint': 'Kategorienummern; Eingabe mit Enter bestätigen',
  'galleries.rules.frozen': 'Enthält nicht übersetzbare Altbegriffe und bleibt unverändert; Sie können die Regel nur entfernen.',
  'galleries.rules.removeScripts': 'Altskript durch diese Regeln ersetzen',
  'galleries.rules.removeScriptsLocked': 'Erst damit wird die Sperre der Altregeln aufgehoben.',
  'galleries.rules.legacyMatch': 'Diese Galerie vergleicht wie im bisherigen PAT auch Wortteile; das gilt für alle ihre Regeln, auch neue.',
  'galleries.rules.sourceOptional': 'Leer lassen: gilt für jedes Angebot',
  'galleries.rules.priorityRange': 'Priorität muss eine ganze Zahl von 0 bis 9 sein',
  'galleries.edit.range': '{field}: bitte eine ganze Zahl von {min} bis {max}',
  'galleries.edit.invalid': 'Die Einstellungen sind unvollständig',
  'galleries.colors.invalid': 'Bitte sechsstelliges Hex wie #1a4d80',
  'galleries.match.runDraft': 'Vorschau mit Entwurf',
  'items.patSearch': 'PAT-Suchtext',
  'articles.title': 'Artikelbeschreibungen',
  'articles.empty': 'Noch keine Artikel angelegt.',
  'articles.count': '{count} Artikel',
  'articles.group.label': 'Gruppe',
  'articles.group.all': 'Alle Gruppen',
  'articles.group.none': 'Ohne Gruppe',
  'articles.group.add': 'Neue Gruppe',
  'articles.group.newName': 'Name der neuen Gruppe',
  'articles.group.create': 'Anlegen',
  'articles.group.manage': 'Gruppen verwalten',
  'articles.group.name': 'Name der Gruppe {name}',
  'articles.group.save': 'Speichern',
  'articles.group.delete': 'Löschen',
  'articles.group.deleteBlocked': 'Nur Gruppen ohne Artikel lassen sich löschen.',
  'articles.group.deleteBlockedDeleted': 'Gelöschte Artikel verweisen noch auf diese Gruppe; sie lässt sich deshalb nicht löschen.',
  'articles.group.empty': 'Noch keine Gruppen.',
  'articles.app2Delete.open': 'Alle App-2-Artikel löschen',
  'articles.app2Delete.title': 'Alle App-2-Artikel löschen',
  'articles.app2Delete.confirm':
    '{count} Artikel aus App 2 werden gelöscht. Sie verschwinden aus der Liste; gespeicherte Stände bleiben im System erhalten. Artikel mit offenem Auftrag bleiben bestehen; mit Angeboten verknüpfte zeigt der Dialog danach getrennt zum Bestätigen.',
  'articles.app2Delete.start': '{count} Artikel löschen',
  'articles.app2Delete.progress.label': 'Fortschritt',
  'articles.app2Delete.progress': '{done} von {total} bearbeitet, {deleted} gelöscht …',
  'articles.app2Delete.done': 'Fertig: {done} von {total} bearbeitet, {deleted} gelöscht.',
  'articles.app2Delete.retry': 'Erneut versuchen ({count})',
  'articles.app2Delete.tenantUnavailable': 'Löschen ist für dieses Konto gerade nicht möglich.',
  'articles.app2Delete.unknownOutcome':
    'Bei mindestens einem Artikel ist der Ausgang unklar. Er gilt nicht als gelöscht; bitte nicht erneut versuchen und den Support informieren.',
  'articles.app2Delete.reason.assigned': 'Mit Angeboten verknüpft: Löschen mit Lösen der Zuordnung bestätigen.',
  'articles.app2Delete.assigned': '{count} Artikel sind eBay-Angeboten zugeordnet und wurden noch nicht gelöscht.',
  'articles.app2Delete.unassign': 'Zuordnung lösen und {count} löschen',
  'articles.app2Delete.reason.intents': 'Offener Auftrag für diesen Artikel: später erneut versuchen.',
  'articles.app2Delete.reason.reassigned': 'Während des Löschens neu zugeordnet, Löschen zurückgenommen: erneut versuchen.',
  'articles.app2Delete.reason.limit': 'Zu viele verknüpfte Einträge: bitte den Support informieren.',
  'articles.app2Delete.reason.refused': 'Nicht gelöscht.',
  'articles.app2Delete.reason.retry': 'Gerade nicht möglich: erneut versuchen.',
  'articles.app2Delete.reason.unknown': 'Ausgang unklar, gilt nicht als gelöscht.',
  'articles.more': 'Weitere laden ({shown} von {total})',
  'articles.search.label': 'Artikel suchen',
  'articles.search.placeholder': 'Suchen nach Titel, SKU oder Alt-Artikelnummer',
  'articles.search.matches': '{count} Treffer',
  'articles.search.none': 'Keine passenden Artikel gefunden.',
  'articles.create.open': 'Neuer Artikel',
  'articles.create.title': 'Neuen Artikel anlegen',
  'articles.create.submit': 'Anlegen',
  'articles.field.title': 'Titel',
  'articles.field.sku': 'Artikelnummer (SKU)',
  'articles.field.design': 'Design',
  'articles.field.noDesign': 'Nur Beschreibung (ohne Design)',
  'articles.col.picture': 'Bild',
  'articles.picture.alt': 'Vorschaubild',
  'articles.col.state': 'Stand',
  'articles.col.updated': 'Geändert',
  'articles.col.actions': 'Aktionen',
  'articles.state.draft': 'Entwurf',
  'articles.state.published': 'veröffentlicht',
  'articles.state.changed': 'geändert seit Veröffentlichung',
  'articles.block.header': 'Überschrift',
  'articles.block.text': 'Text',
  'articles.block.picture': 'Bilder',
  'articles.block.html': 'HTML',
  'articles.block.video': 'Video',
  'articles.block.label': 'Block {n}: {type}',
  'articles.block.up': 'Nach oben',
  'articles.block.down': 'Nach unten',
  'articles.block.add': 'Block hinzufügen:',
  'articles.block.invalid': 'Angaben unvollständig oder zu lang',
  'articles.block.videoUrl': 'Bitte eine https-Adresse des Videos angeben',
  'articles.block.pictureSource': 'Jedes Bild braucht eine Medien-ID oder https-Adresse',
  'articles.block.pictureUrl': 'Bildadresse bitte als vollständige https-Adresse',
  'articles.block.mediaId': 'Ungültige Medien-ID',
  'articles.designUnavailable': 'Das bisher gewählte Design gibt es nicht mehr; bitte ein Design wählen.',
  'articles.newer.title': 'Neuere Version vorhanden',
  'articles.newer.text': 'Der Artikel wurde inzwischen anderswo gespeichert. Ihre Änderungen hier sind noch nicht gespeichert.',
  'articles.newer.reload': 'Neuere Version laden (eigene Änderungen verwerfen)',
  'articles.preview.designLoading': 'Design wird geladen …',
  'articles.preview.designFailed': 'Das gewählte Design konnte nicht geladen werden.',
  'articles.preview.designUnpublished': 'Dieses Design ist noch nicht veröffentlicht; so kann der Artikel nicht an eBay gesendet werden.',
  'articles.preview.designDraft': 'Vorschau mit der veröffentlichten Designfassung; der neuere Entwurf (Version {version}) gilt erst nach dessen Veröffentlichung.',
  'articles.publish': 'Veröffentlichen',
  'articles.publish.saveFirst': 'Zum Veröffentlichen zuerst den Entwurf speichern.',
  'articles.publish.done': 'Veröffentlicht.',
  'articles.publish.blocked': 'Zum Veröffentlichen zuerst diese Fehler beheben: {codes}',
  'articles.designOutdated': 'Veröffentlicht mit Designfassung {bound}; aktuell veröffentlicht ist Fassung {current}.',
  'articles.designOutdated.action': 'Zum Übernehmen den Entwurf speichern und neu veröffentlichen.',
  'articles.publish.galleriesLoading': 'Galerien und zugeordnete Angebote werden geprüft …',
  'articles.publish.galleriesFailed': 'Galerien oder zugeordnete Angebote konnten nicht geladen werden; Hinweise zu Galerieboxen fehlen. Veröffentlichen ist trotzdem möglich.',
  'articles.revise.requested': 'Die Beschreibungen der zugeordneten Angebote werden aktualisiert.',
  'articles.revise.queued': 'Die Übertragung an eBay ist in dieser Umgebung noch nicht aktiv; Aufträge je Angebot sind erst danach möglich.',
  'articles.revise.order-required': 'Die Beschreibungen bei eBay ändern sich erst, wenn Sie sie unten je Angebot beauftragen.',
  'articles.revise.order-deferred':
    'Sie können unten je Angebot beauftragen. In dieser Testumgebung ist die Übertragung an eBay noch nicht freigegeben; PAT führt angenommene Aufträge erst danach aus.',
  'articles.revise.opt-in-off': 'Live-Update ist ausgeschaltet; PAT schreibt nichts in Ihre Beschreibungen. Nach dem Einschalten unter „eBay & Live-Update“ können Sie je Angebot beauftragen.',
  'articles.items.order': 'Beschreibung ersetzen',
  'articles.items.ordered': 'beauftragt',
  'articles.items.orderedDeferred': 'Übertragung an eBay folgt nach Freigabe',
  'articles.copy': 'Artikel kopieren',
  'articles.copy.short': 'Kopieren',
  'articles.delete': 'Löschen',
  'articles.delete.title': 'Artikel löschen',
  'articles.delete.text': '„{title}“ wird gelöscht und erscheint danach nicht mehr in der Liste.',
  'articles.delete.assigned.title': 'Mit Angeboten verknüpft',
  'articles.delete.assigned.one': 'Der Artikel ist einem eBay-Angebot zugeordnet.',
  'articles.delete.assigned.text': 'Der Artikel ist {n} eBay-Angeboten zugeordnet.',
  'articles.delete.assigned.many': 'Der Artikel ist mehr als {n} eBay-Angeboten zugeordnet.',
  'articles.delete.assigned.confirm': 'Zuordnung lösen und trotzdem löschen. Die Beschreibungen bei eBay bleiben unverändert.',
  'articles.delete.changed': 'Der Artikel wurde inzwischen geändert: bitte erneut löschen.',
  'articles.delete.tenant': 'Löschen ist für dieses Konto gerade nicht möglich.',
  'articles.delete.unassignFailed': 'Die Zuordnung ließ sich gerade nicht lösen: bitte erneut versuchen.',
  'articles.imported': 'Importiert · App {app} · Nr. {number}',
  'articles.imported.app': 'Importiert · App {app}',
  'articles.app2.hint': 'Aus dem älteren Editor (App 2.0) übernommen und in Blöcke umgewandelt; bitte Darstellung prüfen.',
  'articles.origin.label': 'Herkunft',
  'articles.origin.all': 'Alle',
  'articles.origin.app': 'Neu (App 4)',
  'articles.origin.app3': 'Importiert (App 3)',
  'articles.origin.app2': 'Importiert (App 2)',
  'articles.imported.hint': 'Aus dem bisherigen PAT übernommen (Artikelnummer {number}), als veröffentlichte Fassung.',
  'start.store.title': 'Shopkategorien',
  'start.store.count': 'Kategorien übernommen',
  'start.store.asOf': 'Stand',
  'start.store.none': 'Für dieses Konto ist kein eBay-Shop hinterlegt.',
  'start.store.unknown': 'Ob ein eBay-Shop besteht, ist noch nicht bekannt.',
  'start.store.missing': 'Die Shopkategorien werden mit dem Kontoimport übernommen.',
  'start.manage': 'Verwalten',
  'start.liveUpdate.on': 'PAT hält die Galerien in Ihren Beschreibungen aktuell.',
  'start.liveUpdate.off': 'Ohne Live-Update bleiben Galerien leer.',
  'start.liveUpdate.switchOn': 'Einschalten',
  'start.import.running': 'Ihre Daten werden gerade aus dem bisherigen PAT übernommen.',
  'start.steps.title': 'So entsteht Ihre Artikelbeschreibung',
  'start.steps.designs': 'Design wählen oder anpassen.',
  'start.steps.articles': 'Artikel anlegen, Design zuordnen und veröffentlichen.',
  'start.steps.copy.title': 'HTML kopieren',
  'start.steps.copy': 'Beim veröffentlichten Artikel „HTML kopieren“ wählen und den Code bei eBay in die Artikelbeschreibung einfügen.',
  'start.next.title': 'Daran arbeiten wir gerade noch',
  'start.next.badge': 'In Arbeit',
  'start.next.intro': 'Diese Bereiche kommen nach und nach dazu. Fragen beantworten wir gern unter {email}.',
  'start.next.galleries': 'Cross-Selling-Galerien bearbeiten',
  'start.next.galleries.text': 'Galerien und ihre Regeln hier anlegen und ändern; bis dahin lassen sie sich ansehen.',
  'start.next.revise': 'Beschreibungen direkt bei eBay aktualisieren',
  'start.next.revise.text': 'Artikel mit Angeboten verknüpfen und die Beschreibung von PAT übertragen lassen; bis dahin mit „HTML kopieren“.',
  'start.next.upload': 'Bilder hochladen',
  'start.next.upload.text': 'Neue Bilder direkt hier hochladen; die vorhandenen stehen schon zur Auswahl.',
  'start.next.designExport': 'Designs exportieren',
  'start.next.designExport.text': 'Ein Design als Datei sichern und weitergeben.',
  'start.next.account': 'Kundendaten und Rechnungen',
  'start.next.account.text': 'Rechnungsdaten einsehen und pflegen, Rechnungen abrufen.',
  'articles.export.open': 'HTML kopieren',
  'articles.export.unpublished': 'Erst nach dem Veröffentlichen: kopiert wird immer die veröffentlichte Fassung',
  'articles.export.publishFirst': 'Erst veröffentlichen, dann kopieren',
  'articles.export.title': 'HTML für eBay kopieren',
  'articles.export.intro': 'Veröffentlichte Fassung {article} mit Design-Fassung {design}. Bei eBay die Beschreibung im HTML-Modus öffnen und vollständig durch diesen Code ersetzen.',
  'articles.export.code': 'Beschreibungscode',
  'articles.export.variant.full': 'Komplett mit Design',
  'articles.export.variant.description': 'Nur Beschreibung (z. B. Afterbuy, Plenty)',
  'articles.export.noDesign': 'Dieser Artikel ist ohne Design veröffentlicht; kopierbar ist nur die Beschreibung.',
  'articles.export.introDescription': 'Veröffentlichte Fassung {article}, nur Beschreibung und Bilder ohne Design und ohne Galerien, für Werkzeuge mit eigenem Design.',
  'articles.export.copy': 'In die Zwischenablage kopieren',
  'articles.export.copied': 'Kopiert.',
  'articles.export.copyFailed': 'Kopieren nicht möglich; bitte den Code markieren und mit Strg+C kopieren.',
  'articles.export.hint': 'Mit eingeschaltetem Live-Update hält PAT die Galerien im eingefügten Code aktuell; sonst ändert PAT die Beschreibung bei eBay nicht.',
  'articles.export.gallery.ok': 'Galerie „{name}“: {n} Angebote im Code, das Live-Update passt sie je Angebot an.',
  'articles.export.gallery.not-found': 'Galerie „{name}“ gibt es nicht mehr; die Box bleibt leer.',
  'articles.export.gallery.not-imported': 'Galerie „{name}“ wurde im neuen PAT angelegt und kann noch nicht ausgeliefert werden; die Box bleibt vorerst leer.',
  'articles.export.gallery.cross-selling-off': 'Galerie „{name}“: Cross-Selling ist für dieses Konto nicht freigeschaltet; die Box bleibt leer.',
  'articles.export.gallery.source-unavailable': 'Galerie „{name}“: Die Herkunft (weiteres eBay-Konto) ist gerade nicht prüfbar; die Box bleibt leer.',
  'articles.export.gallery.identity-missing': 'Galerie „{name}“: Für dieses Konto fehlt die öffentliche Galeriekennung; die Box bleibt leer.',
  'articles.export.gallery.selection-unavailable': 'Galerie „{name}“: Die Angebotsauswahl ist gerade nicht berechenbar; der Block startet leer und füllt sich über das Live-Update.',
  'articles.items.orderRunning': 'beauftragt, läuft',
  'articles.items.orderRunningSince': 'seit {date}',
  'articles.items.orderRunningOlder': 'Fassung {version} ist seit {date} beauftragt und läuft noch.',
  'articles.items.orderFailed': 'Der Auftrag vom {date} ließ sich nicht starten; bitte erneut beauftragen.',
  'items.writeUnresolved': 'Schreibausgang ungeklärt',
  'items.writeUnresolvedSince': 'seit {date}; neu beauftragen ist gesperrt, bis PAT ihn geklärt hat',
  'articles.items.orderTitle': 'Beschreibung bei eBay ersetzen',
  'articles.items.orderText': 'PAT ersetzt die gesamte Beschreibung des Angebots {id} bei eBay durch die veröffentlichte Fassung dieses Artikels (derzeit Fassung {version}). Die bisherige Beschreibung wird vorher gesichert.',
  'articles.items.orderConfirm': 'Ersetzen beauftragen',
  'articles.items.adoptHint': 'Beim ersten Lauf liest PAT die bestehende Beschreibung der neu zugeordneten Angebote nur ein; ersetzt wird sie nur auf Ihren Auftrag je Angebot.',
  'articles.revise.none': 'Es sind keine laufenden Angebote betroffen.',
  'articles.revise.jobs-off': 'Für dieses Konto laufen noch keine Abgleiche; Aufträge je Angebot sind noch nicht möglich.',
  'articles.revise.paused': 'Der Abgleich ist pausiert; Aufträge je Angebot sind erst nach der Freigabe möglich.',
  'articles.revise.live-update-off': 'Live-Update ist im Tarif dieses Kontos nicht enthalten; PAT ändert keine Beschreibungen bei eBay.',
  'articles.revise.sync-incomplete': 'Der erste vollständige Abgleich steht noch aus; Aufträge je Angebot sind erst danach möglich.',
  'articles.revise.ebay-disconnected': 'Die eBay-Verbindung fehlt oder ist abgelaufen; Aufträge je Angebot sind erst nach dem Neuverbinden möglich.',
  'articles.revise.account-inactive': 'Das Konto ist nicht aktiv; PAT ändert keine Beschreibungen bei eBay.',
  'articles.revise.failed': 'Die Aktualisierung konnte nicht vorgemerkt werden.',
  'articles.items.title': 'Zugeordnete Angebote',
  'articles.items.none': 'Diesem Artikel sind noch keine Angebote zugeordnet.',
  'articles.items.remove': 'Lösen',
  'articles.items.add': 'Angebote zuordnen',
  'articles.items.addHint': 'eBay-Angebotsnummern, getrennt durch Leerzeichen oder Komma (höchstens 100)',
  'articles.items.invalid': 'Keine Angebotsnummer: {id}',
  'articles.items.assign': 'Zuordnen',
  'articles.items.bySku': 'Alle aktiven Angebote mit SKU {sku} zuordnen',
  'articles.items.bySkuNone': 'Keine aktiven Angebote mit dieser Artikelnummer gefunden.',
  'articles.items.result': '{added} zugeordnet, {removed} gelöst.',
  'articles.items.removedKeep': 'Gelöste Angebote behalten ihre Beschreibung auf eBay.',
  'articles.items.missing': 'Nicht im Konto gefunden: {ids}',
  'articles.items.truncated': 'Es sind mehr Angebote zugeordnet; angezeigt werden die neuesten.',
  'articles.items.searchTruncated': 'Die Suche nach der Artikelnummer wurde an der Obergrenze beendet; es kann weitere Treffer geben. Bitte erneut ausführen.',
  'richText.icon.pick': 'Symbol einfügen',
  'richText.icon.search': 'Suchen (englisch, z. B. truck, check, phone)',
  'richText.icon.none': 'Kein Symbol gefunden.',
  'articles.text.twoColumns': 'Zwei Spalten',
  'articles.text.second': 'Text zweite Spalte',
  'articles.html.hint': 'Skripte und aktive Inhalte entfernt die Vorschau wie eBay; was übrig bleibt, wird veröffentlicht.',
  'articles.picture.source': 'Bild',
  'articles.picture.sourceHint': 'Medien-ID oder https-Adresse',
  'articles.picture.label': 'Bildunterschrift',
  'articles.picture.thumb': 'Vorschaubild',
  'articles.picture.add': 'Bild hinzufügen',
  'articles.picture.format': 'Bildanordnung',
  'articles.picture.format.list': 'untereinander',
  'articles.picture.format.prevtop': 'Vorschaubilder oben',
  'articles.picture.format.prevbottom': 'Vorschaubilder unten',
  'articles.picture.legacyInline': 'Eingebettetes Bild aus dem bisherigen PAT (bleibt unverändert)',
  'articles.video.url': 'Video-Adresse (https)',
  'articles.video.thumbnail': 'Vorschaubild (Medien-ID)',
  'articles.preview.noDesign': 'Für die Vorschau bitte ein Design wählen.',
  'articles.preview.articleOnly': 'Nur Beschreibung: ohne Design, CSS und Galerien, wie „HTML kopieren“ → „Nur Beschreibung“.',
  'articles.publish.needsDesign': 'Zum Veröffentlichen bitte ein Design wählen.',
  'articles.preview.noArticleBox': 'Dieses Design hat keine Artikelbox; der Artikeltext erscheint darin nicht.',
  'articles.galleriesWithoutLiveUpdate': 'Live-Update ist ausgeschaltet: Ohne Live-Update liest PAT Ihre Angebote nicht ein, deshalb bleiben Galerien in der Vorschau und in „HTML kopieren“ leer oder zeigen keinen aktuellen Stand. Das ist kein Fehler. Einschalten können Sie Live-Update unter „eBay & Live-Update“.',
  'articles.save': 'Entwurf speichern',
  'articles.saved': 'Gespeichert.',
  'articles.designEdit': 'Design bearbeiten',
  'frozen.title': 'Nicht verfügbar',
  'frozen.text': 'Diese Funktion ist im neuen Kundenbereich vorerst nicht verfügbar.',
  'preview.title': 'Vorschau',
  'preview.open': 'Vorschau',
  'preview.desktop': 'Desktop',
  'preview.laptop': 'Laptop',
  'preview.tablet': 'Tablet',
  'preview.mobile': 'Mobil',
  'preview.failed': 'Die Vorschau konnte nicht erstellt werden.',
  'render.warning.active-content': 'Aktive Inhalte entfernt',
  'render.warning.media-base-invalid': 'Bildquelle ungültig, Hostingbasis verwendet',
  'render.warning.insecure-url': 'Unsichere Adresse angepasst',
  'render.warning.css-neutralized': 'Eigenes CSS entschärft',
  'render.warning.css-value-invalid': 'Ungültiger Stilwert ersetzt',
  'render.warning.design-value-invalid': 'Ungültiger Designwert ersetzt',
  'render.warning.mobile-description-cut': 'eBay-Kurztext begrenzt; vollständige Artikelbeschreibung unverändert',
  'render.warning.media-missing': 'Bild nicht gefunden',
  'render.warning.gallery-embed-missing': 'Galeriebox in der Vorschau ohne Inhalt',
  'render.warning.gallery-embed-invalid': 'Ungültiger Galerie-Einbettcode',
  'render.warning.gallery-embed-color': 'Galerie ohne Designfarben',
  'render.warning.block-skipped': 'Block ausgelassen',
  'render.warning.box-column-invalid': 'Box mit ungültiger Spalte ausgelassen',
  'render.warning.box-not-implemented': 'Boxart nicht unterstützt',
  'render.warning.block-not-implemented': 'Blockart nicht unterstützt',
  'render.warning.variant-invalid': 'Designvariante ersetzt',
  'render.warning.shop-navi-data-missing': 'Shopnavigation ohne Daten',
  'render.warning.shop-navi-no-store': 'Shopkategorien in der Vorschau ohne Shopdaten',
  'render.warning.output-unsafe': 'Unsicherer Inhalt in der Ausgabe',
  'render.warning.gallery-block-unclosed': 'Galerieblock ohne Ende',
  'render.warning.gallery-block-ambiguous': 'Galerieblock nicht eindeutig',
  'render.warning.gallery-block-limit': 'Zu viele Galerieblöcke',
  'render.warning.gallery-action-unknown': 'Unbekannte Galerieaktion',
  'render.warning.trust-too-many': 'Zu viele Vertrauenselemente (zentriert höchstens 5)',
  'render.warning.render-failed': 'Darstellung nicht möglich',
  'designs.blocker.article-box-missing': 'Artikelbox fehlt',
  'designs.blocker.article-box-duplicate': 'Mehr als eine Artikelbox',
  'designs.blocker.box-id-duplicate': 'Box doppelt vorhanden',
  'designs.blocker.too-large': 'Design zu groß; bitte Boxtexte oder Zusatzcode kürzen',
  'designs.hint.gallery-box-unassigned': 'Galeriebox bleibt leer: keine Galerie gewählt.',
  'designs.hint.gallery-unavailable': 'Galeriebox bleibt leer: die gewählte Galerie gibt es nicht (mehr).',
  'designs.hint.cross-selling-off': 'Galeriebox bleibt leer: Cross-Selling ist für dieses Konto nicht freigeschaltet.',
  'designs.hint.gallery-locked': 'Galeriebox bleibt leer: die Regeln der Galerie sind bis zur Prüfung gesperrt.',
  'designs.hint.gallery-site-differs': 'Galeriebox bleibt leer bei Angeboten auf einer anderen eBay-Site als die gewählte Galerie.',
  'designs.title': 'Designs',
  'designs.empty': 'Noch keine Designs angelegt.',
  'designs.col.name': 'Name',
  'designs.col.variant': 'Variante',
  'designs.col.state': 'Stand',
  'designs.col.articles': 'Artikel',
  'designs.col.updated': 'Geändert',
  'designs.col.actions': 'Aktionen',
  'designs.variant': 'Variante {n} (Aufbau {s}, Grauton {g})',
  'designs.export.open': 'Exportieren',
  'designs.export.publishFirst': 'Erst veröffentlichen, dann exportieren',
  'designs.export.title': 'Design exportieren',
  'designs.export.intro': 'Exportiert die veröffentlichte Fassung als Vorlage für Ihr Listing-Programm. Titel, Beschreibung und Bilder ersetzt das Programm über seine Platzhalter.',
  'designs.export.platform': 'Plattform',
  'designs.export.platform.none': 'Nur Design ohne Beschreibung',
  'designs.export.platform.afterbuy': 'Afterbuy',
  'designs.export.platform.dreamrobot': 'DreamRobot',
  'designs.export.platform.eazyAuction': 'eazyAuction (JTL)',
  'designs.export.platform.magnalister': 'magnalister',
  'designs.export.platform.plentyMarkets': 'plentyMarkets',
  'designs.export.pictures': 'Bilder',
  'designs.export.pictures.insert': 'Platzhalter für Bilder einfügen',
  'designs.export.picturePosition': 'Bild-Position',
  'designs.export.picturePosition.below': 'Unter die Beschreibung',
  'designs.export.picturePosition.above': 'Über die Beschreibung',
  'designs.export.pictureFormat': 'Bild-Format',
  'designs.export.pictureFormat.list': 'Liste (untereinander)',
  'designs.export.pictureFormat.preview-top': 'Vorschau oben',
  'designs.export.pictureFormat.preview-bottom': 'Vorschau unten',
  'designs.export.placeholders': 'Platzhalter',
  'designs.export.placeholder.title': 'Titel',
  'designs.export.placeholder.description': 'Beschreibung',
  'designs.export.pictureCount': 'Anzahl Bilder',
  'designs.export.picture': 'Bild {n}',
  'designs.export.picture.add': 'Bild hinzufügen',
  'designs.export.picture.remove': 'Bild entfernen',
  'designs.export.output': 'Ausgabe',
  'designs.export.output.text': 'Als Text anzeigen',
  'designs.export.output.file': 'Als Datei herunterladen',
  'designs.export.fileExtension': 'Dateiformat',
  'designs.export.fileExtension.txt': 'Text',
  'designs.export.fileExtension.html': 'HTML',
  'designs.export.plentyVersion': 'Plenty-Version',
  'designs.export.run': 'Exportieren',
  'designs.export.runSave': 'Speichern und exportieren',
  'designs.export.readOnly': 'Mit Ihrer Rolle werden die Einstellungen nicht gespeichert.',
  'designs.export.code': 'HTML-Code',
  'designs.export.copyHint': 'Design-Fassung {version}. Kopieren Sie den HTML-Code und fügen Sie ihn in Ihr Listing-Programm ein.',
  'designs.export.downloaded': 'Design-Fassung {version} als Datei heruntergeladen.',
  'designs.copy': 'Kopieren',
  'designs.delete': 'Löschen',
  'designs.delete.title': 'Design löschen',
  'designs.delete.text': '„{name}“ wird gelöscht und erscheint danach nicht mehr in der Liste.',
  'designs.delete.unused': 'Kein Artikel verwendet dieses Design.',
  'designs.delete.usedOne': 'Das Design wird noch von einem Artikel verwendet. Wählen Sie dort zuerst ein anderes Design.',
  'designs.delete.usedMany': 'Das Design wird noch von {n} Artikeln verwendet. Wählen Sie dort zuerst ein anderes Design.',
  'designs.create.open': 'Neues Design',
  'designs.create.title': 'Neues Design aus Vorlage',
  'designs.create.hint': 'Aus der Vorlage kommen Farben und Variante; Boxen, Links und Vertrauenselemente legt PAT als Grundgerüst an. Alles lässt sich danach bearbeiten.',
  'designs.create.template': 'Vorlage',
  'designs.create.noTemplates': 'Es sind noch keine Vorlagen vorhanden.',
  'designs.create.gallery': 'Galerie für „Weitere interessante Angebote“',
  'designs.create.galleryNone': 'keine',
  'designs.create.showStoreCategories': 'Shopkategorien anzeigen',
  'designs.create.showStoreCategoriesHint': 'Zeigt die Kategorien Ihres eBay-Shops; ohne Shop lässt PAT die Box im Angebot weg.',
  'designs.create.submit': 'Anlegen',
  'designs.field.name': 'Name',
  'designs.field.logoText': 'Logo-Text',
  'designs.field.copyright': 'Copyright',
  'designs.tab.general': 'Allgemein',
  'designs.tab.colors': 'Farben',
  'designs.tab.boxes': 'Boxen',
  'designs.tab.links': 'Links und Vertrauen',
  'designs.tab.code': 'Zusatzcode',
  'designs.header.title': 'Kopfbereich',
  'designs.logo.type': 'Logo-Art',
  'designs.logo.type.text': 'Text',
  'designs.logo.type.image': 'Bild',
  'designs.logo.type.html': 'HTML',
  'designs.logo.html': 'Logo-HTML',
  'designs.logo.image': 'Logo-Bild',
  'designs.logo.imageHint': 'Medien-ID oder https-Adresse',
  'designs.logo.stretch': 'Auf volle Breite strecken',
  'designs.logo.paddingTop': 'Abstand oben (px)',
  'designs.logo.paddingBottom': 'Abstand unten (px)',
  'designs.logo.paddingHint': 'Abstände wirken nur bei einem nicht gestreckten Bild.',
  'designs.colors.locked': 'Farben, Schrift und Variante sind für dieses Konto nicht änderbar. „Vorlage wechseln“ ist trotzdem möglich.',
  'designs.colors.font': 'Schriftart',
  'designs.colors.fontSize': 'Schriftgröße',
  'designs.colors.fontSize.1': 'klein (10 pt)',
  'designs.colors.fontSize.2': 'mittel (12 pt)',
  'designs.colors.fontSize.3': 'groß (14 pt)',
  'designs.colors.body_bg': 'Seitenhintergrund',
  'designs.colors.color_1_bg': 'Kopfbereich',
  'designs.colors.color_2_bg': 'Boxüberschriften',
  'designs.colors.bgType': 'Art',
  'designs.colors.bgType.0': 'keiner',
  'designs.colors.bgType.1': 'Farbe',
  'designs.colors.bgType.2': 'Verlauf',
  'designs.colors.bgType.9': 'Bild',
  'designs.colors.color1': 'Farbe',
  'designs.colors.color1Gradient': 'Farbe oben',
  'designs.colors.color2': 'Farbe unten',
  'designs.colors.image': 'Bildadresse (https)',
  'designs.colors.repeat': 'Wiederholen',
  'designs.colors.position': 'Position',
  'designs.colors.size': 'Größe',
  'designs.colors.overlay': 'Mit Muster-Überlagerung',
  'designs.colors.overlayRemove': 'Muster entfernen',
  'designs.colors.fontColor': 'Schriftfarbe',
  'designs.colors.own2': 'Eigene Farben für Boxüberschriften',
  'designs.colors.own2Hint': 'Aus: Boxüberschriften übernehmen Schrift- und Hintergrundfarbe des Kopfbereichs.',
  'designs.colors.customCss': 'Eigenes CSS',
  'designs.colors.customCssHint': 'Wird an das Design-CSS angehängt.',
  'designs.boxes.column.1': 'Linke Spalte',
  'designs.boxes.column.2': 'Hauptspalte',
  'designs.boxes.column.3': 'Fußbereich',
  'designs.boxes.empty': 'Keine Boxen in dieser Spalte.',
  'designs.boxes.add': 'Hinzufügen:',
  'designs.box.text': 'Textbox',
  'designs.box.gallery': 'Galeriebox',
  'designs.box.shop-navi': 'Shopkategorien',
  'designs.box.article': 'Artikelbox',
  'designs.box.label': '{column}, Box {n}: {type}',
  'designs.box.headline': 'Überschrift',
  'designs.box.hideHeadline': 'Überschrift ausblenden',
  'designs.box.icon': 'Symbol',
  'designs.box.iconHint': 'Font-Awesome-4-Name, z. B. truck',
  'designs.box.html': 'Inhalt (HTML)',
  'designs.box.up': 'Nach oben',
  'designs.box.down': 'Nach unten',
  'designs.box.column': 'Spalte',
  'designs.box.remove': 'Entfernen',
  'designs.box.newHeadline': 'Neue Box',
  'designs.box.galleryHeadline': 'Weitere interessante Angebote',
  'designs.box.gallerySelect': 'Galerie',
  'designs.box.galleryNone': 'keine Galerie gewählt',
  'designs.box.galleryMissing': 'Die gewählte Galerie gibt es nicht mehr; die Box bleibt leer.',
  'designs.box.galleryLocked': 'Die Regeln dieser Galerie sind bis zur Prüfung gesperrt; die Box bleibt so lange leer.',
  'designs.box.galleryOff': 'Cross-Selling ist für dieses Konto nicht freigeschaltet; die Box bleibt leer.',
  'designs.box.articleHint': 'Hier erscheint die Artikelbeschreibung. Die Box lässt sich verschieben, aber nicht entfernen.',
  'designs.box.textTooLong': 'Der Inhalt ist zu lang.',
  'designs.shopNavi.active': 'Shopkategorien anzeigen',
  'designs.shopNavi.order': 'Reihenfolge',
  'designs.shopNavi.order.ebay': 'wie bei eBay',
  'designs.shopNavi.order.name': 'alphabetisch',
  'designs.shopNavi.filter': 'Kategorien',
  'designs.shopNavi.filter.all': 'alle',
  'designs.shopNavi.filter.with-items': 'nur mit Angeboten',
  'designs.shopNavi.filter.all-with-other': 'alle mit „Sonstige“',
  'designs.shopNavi.depth': 'Ebenen',
  'designs.shopNavi.depth.0': 'nur Hauptkategorien',
  'designs.shopNavi.depth.1': 'zwei Ebenen',
  'designs.shopNavi.depth.2': 'drei Ebenen',
  'designs.links.title': 'Links',
  'designs.links.add': 'Link hinzufügen',
  'designs.links.row': 'Link {n}',
  'designs.links.linkTitle': 'Titel',
  'designs.links.url': 'Adresse',
  'designs.links.none': 'Keine Links.',
  'designs.trust.title': 'Vertrauenselemente',
  'designs.trust.add': 'Element hinzufügen',
  'designs.trust.row': 'Vertrauenselement {n}',
  'designs.trust.none': 'Keine Vertrauenselemente.',
  'designs.trust.align': 'Ausrichtung',
  'designs.trust.align.left': 'links',
  'designs.trust.align.center': 'mittig',
  'designs.trust.align.right': 'rechts',
  'designs.code.css': 'Zusätzliches CSS',
  'designs.code.top': 'Code oberhalb',
  'designs.code.bottom': 'Code unterhalb',
  'designs.code.hint': 'Skripte und aktive Inhalte entfernt die Vorschau wie eBay; was übrig bleibt, wird veröffentlicht.',
  'designs.save': 'Entwurf speichern',
  'designs.saved': 'Gespeichert.',
  'designs.invalid': 'Angaben unvollständig oder ungültig',
  'designs.nameRequired': 'Bitte einen Namen angeben',
  'designs.mediaId': 'Ungültige Medien-ID',
  'designs.colorInvalid': 'Bitte die Farbfelder korrigieren (sechsstelliges Hex)',
  'designs.newer.title': 'Neuere Version vorhanden',
  'designs.newer.text': 'Das Design wurde inzwischen anderswo gespeichert. Ihre Änderungen hier sind noch nicht gespeichert.',
  'designs.newer.reload': 'Neuere Version laden (eigene Änderungen verwerfen)',
  'designs.usage.none': 'Von keinem Artikel verwendet',
  'designs.usage.one': 'Von einem Artikel verwendet',
  'designs.usage.many': 'Von {n} Artikeln verwendet',
  'designs.publish': 'Veröffentlichen',
  'designs.publish.saveFirst': 'Zum Veröffentlichen oder Wechseln der Vorlage zuerst den Entwurf speichern.',
  'designs.publish.blocked': 'Vor dem Veröffentlichen beheben: {codes}',
  'designs.publish.confirmTitle': 'Design veröffentlichen',
  'designs.publish.confirmNone': 'Kein Artikel verwendet dieses Design.',
  'designs.publish.confirmOne': 'Ein Artikel verwendet dieses Design.',
  'designs.publish.confirmMany': '{n} Artikel verwenden dieses Design.',
  'designs.publish.noPropagation': 'Bestehende Angebote auf eBay behalten ihre Beschreibung. Die neue Fassung gilt für einen Artikel erst, wenn er neu veröffentlicht wird; neu zugeordnete Angebote erhalten die Designfassung seiner letzten Veröffentlichung.',
  'designs.publish.confirm': 'Jetzt veröffentlichen',
  'designs.publish.done': 'Veröffentlicht.',
  'designs.template.open': 'Vorlage wechseln',
  'designs.template.title': 'Vorlage wechseln',
  'designs.template.hint': 'Übernimmt nur Farben und Variante der Vorlage; Boxen, Texte, Links und Logo bleiben.',
  'designs.template.apply': 'Übernehmen',
  'media.title': 'Medien',
  'media.folder': 'Ordner',
  'media.folder.all': 'Alle',
  'media.folder.p': 'Artikelbilder',
  'media.folder.u': 'Design-Bilder',
  'media.folder.count': '{label} ({n})',
  'media.folder.counting': '{label} (Zahl wird ermittelt)',
  'media.hint': 'Artikelbilder nutzen Sie in Bildblöcken und als Video-Vorschaubild, Design-Bilder als Logo oder Hintergrund. Mit „Adresse kopieren“ lässt sich ein Bild auch in einen HTML-Block einsetzen.',
  'media.uploadSoon': 'Hochladen folgt: Neue Bilder lassen sich hier bald direkt hochladen. Bis dahin stehen die vorhandenen Bilder zur Auswahl.',
  'media.uploadReadOnly': 'Hochladen ist mit Ihrer Rolle oder im aktuellen Umzugsstand nicht möglich.',
  'media.empty': 'In diesem Ordner liegen noch keine Bilder.',
  'media.unavailable': 'Die Medienbibliothek ist in dieser Umgebung noch nicht verfügbar. Medien-IDs und https-Adressen lassen sich weiterhin direkt eintragen.',
  'media.more': 'Mehr laden',
  'media.copy': 'Adresse kopieren',
  'media.copied': 'Adresse kopiert',
  'media.alt': 'Bild {name}',
  'media.size': '{w} × {h} px',
  'media.pick': 'Aus Medien wählen',
  'media.pick.replace': 'Durch Medium ersetzen',
  'media.pick.add': 'Aus Medien hinzufügen',
  'media.pick.choose': '{name} wählen',
  'media.picker.title': 'Bild aus Medien wählen',
  'media.picker.hint': 'Ein Klick auf ein Bild übernimmt es.',
  'media.picker.close': 'Schließen',
  'media.upload': 'Hochladen',
  'media.upload.input': 'Dateien zum Hochladen',
  'media.upload.hint': 'Ziel: {folder}. JPEG, PNG, GIF oder WebP bis {mb} MB; Dateien lassen sich auch auf die Bibliothek ziehen.',
  'media.upload.list': 'Uploads',
  'media.upload.row': 'Upload {name}',
  'media.upload.progress': 'Fortschritt {name}',
  'media.upload.waiting': 'Wartet …',
  'media.upload.uploading': 'Wird hochgeladen … {n} %',
  'media.upload.processing': 'Wird verarbeitet …',
  'media.upload.ready': 'Fertig',
  'media.upload.timeout': 'Zeitüberschreitung: Die Verarbeitung dauert ungewöhnlich lange. „Erneut versuchen“ fragt wieder nach; fertige Bilder erscheinen auch nach dem Neuladen der Seite.',
  'media.upload.retry': 'Erneut versuchen',
  'media.upload.cancel': 'Abbrechen',
  'media.upload.clear': 'Erledigte ausblenden',
  'media.upload.error.type': 'Dateityp nicht erlaubt. Erlaubt sind JPEG, PNG, GIF und WebP.',
  'media.upload.error.size': 'Datei zu groß (höchstens {mb} MB).',
  'media.upload.error.empty': 'Die Datei ist leer.',
  'media.upload.error.conflict': 'Konflikt mit einem früheren Upload dieser Datei. Bitte die Datei erneut auswählen.',
  'media.upload.error.forbidden': 'Keine Berechtigung zum Hochladen in diesem Konto.',
  'media.upload.error.unavailable': 'Hochladen ist in dieser Umgebung nicht verfügbar.',
  'media.upload.error.network': 'Keine Verbindung zum Server. Bitte erneut versuchen.',
  'media.upload.error.transfer': 'Übertragung fehlgeschlagen. Bitte erneut versuchen.',
  'media.upload.error.expired': 'Der Upload ist abgelaufen. Bitte die Datei erneut auswählen.',
  'media.upload.error.too-large': 'Das Bild ist zu groß (über {mb} MB oder zu viele Pixel).',
  'media.upload.error.type-mismatch': 'Der Inhalt passt nicht zum Dateityp. Erlaubt sind echte JPEG-, PNG-, GIF- und WebP-Bilder.',
  'media.upload.error.decode-failed': 'Das Bild konnte nicht gelesen werden; die Datei ist vermutlich beschädigt.',
  'media.upload.error.dimensions': 'Die Bildmaße werden nicht unterstützt.',
  'media.upload.error.quota': 'Kontingent erschöpft: zu viele Uploads auf einmal oder heute (höchstens {n} pro Tag). Bitte später erneut versuchen.',
  'media.upload.error.malware': 'Die Datei wurde als schädlich erkannt und nicht übernommen.',
  'media.upload.error.internal': 'Interner Fehler beim Hochladen. Bitte später erneut versuchen.',
  'media.upload.leave.title': 'Uploads laufen noch',
  'media.upload.leave.text': 'Schließen bricht die laufenden Übertragungen ab.',
  'media.upload.leave.confirm': 'Abbrechen und schließen',
  'media.upload.leave.pickText': 'Übernehmen schließt den Dialog und bricht die laufenden Übertragungen ab.',
  'media.upload.leave.pick': 'Abbrechen und übernehmen',
  'media.upload.leave.stay': 'Weiter hochladen',
  'galleries.preview.title': 'Vorschau',
  'galleries.preview.hint': 'Beliebige aktive Angebote Ihres Kontos, ohne Regeln – wie im bisherigen PAT.',
  'galleries.preview.none': 'Keine aktiven Angebote auf der eBay-Site dieser Galerie.',
  'galleries.embed.title': 'HTML-Code',
  'galleries.embed.copy': 'Kopieren',
  'galleries.embed.copied': 'Kopiert',
  'galleries.match.draft': 'Entwurf',
  'galleries.match.draftInvalid': 'Der Entwurf enthält noch Fehler.',
  'galleries.maxItems': 'Höchstens Angebote',
  'galleries.sort': 'Reihenfolge',
  'galleries.sort.none': 'ohne Sortierung',
  'galleries.sort.newest': 'neueste zuerst',
  'galleries.sort.priceAsc': 'Preis aufsteigend',
  'galleries.sort.priceDesc': 'Preis absteigend',
  'galleries.random': 'zufällig',
  'galleries.titleLines': 'Titelzeilen',
  'galleries.showPrice': 'Preis anzeigen',
  'galleries.showAuctionType': 'Angebotsart anzeigen',
  'galleries.showInfoText': 'Infotext anzeigen',
  'galleries.language': 'Sprache der Galerie',
  'galleries.height': 'Zeilen',
  'galleries.width': 'Breite',
  'galleries.width.auto': 'automatisch',
  'galleries.bigPicture': 'Großes Bild',
  'galleries.sameSiteOnly': 'Nur Angebote derselben eBay-Site',
  'galleries.colors': 'Farben',
  'galleries.colors.default': 'Standard',
  'galleries.colors.c1': 'Hintergrund',
  'galleries.colors.c3': 'Rahmen',
  'galleries.colors.i1': 'Angebot Hintergrund',
  'galleries.colors.i2': 'Angebot Schrift',
  'galleries.colors.i3': 'Angebot Rahmen',
  'galleries.rules': 'Regeln',
  'galleries.script': 'Skript',
  'galleries.scriptLines': '{n} Zeilen',
  'galleries.unsupported': '{n} nicht übersetzbar',
  'galleries.priority': 'Priorität',
  'galleries.ruleKind': 'Art',
  'galleries.ruleDetail': 'Kategorien oder Suchbegriffe',
  'galleries.match.title': 'Regeltest: passende Angebote',
  'galleries.match.hint': 'Wählen Sie ein Angebot; die Vorschau zeigt, welche Angebote die Galerie dazu einblendet. Ohne Auswahl zeigt sie die allgemeine Auswahl.',
  'galleries.match.source': 'Ausgangsangebot',
  'galleries.match.run': 'Vorschau berechnen',
  'galleries.match.none': 'Keine passenden Angebote.',
  'galleries.match.fallback': 'Keine Regel traf zu, allgemeine Auswahl',
  'galleries.match.missing': 'Fehlende Daten',
  'galleries.match.hits': '{n} Treffer',
  'galleries.match.context': 'Regelstand {version}, höchstens {max} Angebote.',
  'galleries.match.crossSite':
    'Das Ausgangsangebot läuft auf {source}, die Galerie zeigt Angebote von {target}. Für Angebote anderer Sites berechnet PAT eine Galerie nur neu, wenn ihr Block schon in der Beschreibung des Angebots steht.',
  'galleries.match.selection.complete': 'Auswahl steht',
  'galleries.match.selection.open': 'Auswahl unsicher',
  'galleries.match.completeness.complete': 'Zählung vollständig',
  'galleries.match.completeness.partial': 'Zählung bis zur Höchstzahl',
  'galleries.match.completeness.unknown': 'Zählung unsicher',
  'galleries.match.missingData.category-hierarchy': 'eBay-Kategoriebaum',
  'galleries.match.missingData.store-hierarchy': 'Shopkategorien',
  'galleries.match.missingData.second-category': 'Zweitkategorie',
  'galleries.match.missingData.title': 'Titel',
  'rules.kind.same-store-category': 'Gleiche Shopkategorie',
  'rules.kind.same-store-main-category': 'Gleiche Shop-Hauptkategorie',
  'rules.kind.same-ebay-category': 'Gleiche eBay-Kategorie',
  'rules.kind.same-ebay-main-category': 'Gleiche eBay-Hauptkategorie',
  'rules.kind.fixed-store-category': 'Feste Shopkategorie',
  'rules.kind.fixed-ebay-category': 'Feste eBay-Kategorie',
  'rules.kind.title-search': 'Titelsuche',
  'rules.kind.group': 'Gruppen',
  'rules.kind.fallback': 'Allgemeine Auswahl',
  'tenants.none': 'Ihrem Zugang ist noch kein Konto zugeordnet. Bitte wenden Sie sich an den Support.',
  'tenants.noneUsable': 'Ihre Konten sind derzeit gesperrt oder noch nicht umgezogen. Bitte wenden Sie sich an den Support.',
  'tenants.unavailable': 'Dieses Konto ist gesperrt oder noch nicht umgezogen.',
  'tenants.locked': 'gesperrt',
  'tenants.closed': 'geschlossen',
  'tenants.notMigrated': 'noch nicht umgezogen',
  'tenants.ebayMissing': '(nicht eingerichtet)',
  'tenants.invoicesOnly': 'nur Rechnungen',
  'tenants.role.owner': 'Inhaber',
  'tenants.role.editor': 'Bearbeiter',
  'tenants.role.viewer': 'Lesend',
  'account.title': 'Konto',
  'account.status.active': 'aktiv',
  'account.status.cancel-scheduled': 'gekündigt',
  'account.status.locked': 'gesperrt',
  'account.status.closed': 'geschlossen',
  'account.features': 'Funktionsumfang',
  'account.feature.designColors': 'Eigene Designfarben',
  'account.feature.crossSelling': 'Cross-Selling-Galerien',
  'account.feature.liveUpdate': 'Live-Update',
  'account.feature.appBeta': 'App-BETA (eingeschränkter Umfang)',
  // Kontaktweg legt Flori noch fest (STUFE_H_PLAN §8 Flori 2); nur diesen Text anpassen.
  'account.contact': 'Änderungen und Kündigung per E-Mail an {email}.',
  /** Kontaktweg (Flori, 25.10.2026): Firmenadresse, als `mailto:` verlinkt. */
  'account.contact.email': 'info@premium-auction-tools.com',
  'account.asOf': 'Stand {date}',
  'account.profile': 'Kundendaten',
  'account.profile.ownerOnly': 'Die Kundendaten sehen nur Inhaber.',
  'account.profile.missing': 'Kundendaten werden mit dem Umzug übernommen.',
  'account.profile.beta': 'Ihre Kundendaten zeigen wir hier in Kürze.',
  'account.profile.unavailable': 'Die Kundendaten folgen.',
  'account.profile.source.import': 'Aus dem bisherigen PAT übernommen.',
  'account.profile.source.app': 'Zuletzt hier geändert.',
  'account.profile.billing': 'Rechnungsdaten',
  'account.profile.billingAsOf': 'Stand {date} · aus dem bisherigen PAT übernommen',
  'account.profile.legalForm': 'Rechtsform',
  'account.profile.legalForm.sole': 'Einzelunternehmen',
  'account.profile.legalForm.company': 'Unternehmen',
  'account.profile.company': 'Firma',
  'account.profile.name': 'Vor- und Nachname',
  'account.profile.address': 'Anschrift',
  'account.profile.country': 'Land',
  'account.profile.vatId': 'USt-IdNr.',
  'account.profile.invoiceAddition': 'Rechnungszusatz',
  'account.profile.payType': 'Zahlart',
  'account.payType.direct-debit': 'Lastschrift',
  'account.payType.invoice': 'Rechnung',
  'account.contactData': 'Kontakt und Erinnerung',
  'account.contactData.hint': 'Gilt für Nachrichten aus PAT, etwa die Erinnerung vor Ablauf der eBay-Verbindung. Rechnungsmails gehen weiter an die bisher hinterlegte Adresse.',
  'account.contactData.phone': 'Telefon',
  'account.contactData.contactEmail': 'Kontakt-E-Mail',
  'account.contactData.ccEmail': 'CC-E-Mail',
  'account.contactData.tokenExpiryReminder': 'Erinnerung vor Ablauf der eBay-Verbindung',
  'account.contactData.emailInvalid': 'Bitte eine gültige E-Mail-Adresse eingeben.',
  'account.contactData.invalid': 'Bitte die Eingaben prüfen.',
  'account.contactData.saved': 'Kontaktdaten gespeichert.',
  'account.contactData.conflict': 'Die Kundendaten wurden inzwischen geändert. Bitte neu laden und die Änderung erneut eingeben.',
  'account.contactData.reload': 'Neu laden',
  'account.invoices': 'Rechnungen',
  'account.invoices.ownerOnly': 'Die Rechnungen sehen nur Inhaber.',
  'account.invoices.unavailable': 'Die Rechnungen folgen.',
  'account.invoices.empty': 'Keine Rechnungen vorhanden.',
  'account.invoices.beta': 'Ihre Rechnungen zeigen wir hier in Kürze.',
  'account.invoices.asOfHint': 'Status und Beträge stammen aus der Buchhaltung; Zahlungseingänge erscheinen mit Verzögerung.',
  'account.invoices.number': 'Nummer',
  'account.invoices.date': 'Datum',
  'account.invoices.period': 'Zeitraum',
  'account.invoices.periodRange': '{from} – {to}',
  'account.invoices.periodFrom': 'ab {from}',
  'account.invoices.periodTo': 'bis {to}',
  'account.invoices.gross': 'Betrag (brutto)',
  'account.invoices.status': 'Status',
  'account.invoices.pdf': 'PDF',
  'account.invoices.pdfLabel': 'PDF der Rechnung {no} herunterladen',
  'account.invoices.pdfFailed': 'Das PDF konnte nicht abgerufen werden.',
  'account.invoices.more': 'Mehr laden',
  // Gesperrt/geschlossen, Inhaber (Entscheidung 25.10.2026): Sperrtext je `accountStatus`, sonst `restricted`.
  'account.invoicesOnly.locked': 'Dieses Konto ist gesperrt. Hier sehen Sie nur noch Ihre Rechnungen.',
  'account.invoicesOnly.closed': 'Dieses Konto ist geschlossen. Hier sehen Sie nur noch Ihre Rechnungen.',
  'account.invoicesOnly.restricted': 'Dieses Konto ist derzeit nicht nutzbar. Hier sehen Sie nur Ihre Rechnungen.',
  'account.invoicesOnly.contact': 'Fragen zum Konto und zu Rechnungen per E-Mail an {email}.',
  'account.invoice.status.open': 'offen',
  'account.invoice.status.reminder': 'Zahlungserinnerung',
  'account.invoice.status.dunning': 'Mahnung',
  'account.invoice.status.paid': 'bezahlt',
  'account.invoice.status.cancelled': 'storniert',
  'account.invoice.status.direct-debit-pending': 'Lastschrift veranlasst',
  'account.members': 'Mitglieder',
  'account.members.member': 'Mitglied',
  'account.members.self': 'Sie',
  'account.members.other': 'Weiteres Mitglied',
  'account.members.role': 'Rolle',
  'account.members.since': 'Mitglied seit',
  'account.members.empty': 'Keine Mitglieder gefunden.',
  'account.members.unavailable': 'Die Mitgliederliste folgt.',
  'account.members.manageLater': 'Mitglieder einladen und verwalten folgt später.',
  'account.members.restricted': 'Die Mitgliederliste sehen Inhaber und Bearbeiter.',
  'account.memberships': 'Ihre Konten',
  'account.memberships.account': 'Konto',
  'account.memberships.status': 'Status',
  'account.memberships.ebay': 'eBay-Name',
  'account.memberships.role': 'Ihre Rolle',
  'account.memberships.current': 'aktuelles Konto',
  'account.memberships.cancelAt': 'gekündigt zum {date}',
  'status.ebay': 'eBay-Verbindung',
  'status.ebay.ok': 'Verbunden',
  'status.ebay.expiring': 'Läuft bald ab',
  'status.ebay.expired': 'Abgelaufen',
  'status.ebay.invalid': 'Ungültig',
  'status.ebay.missing': 'Nicht verbunden',
  'status.ebay.user': 'eBay-Nutzer',
  'status.ebay.expires': 'Gültig bis',
  'status.ebay.daysLeft': 'noch {days} Tage',
  'status.ebay.estimated': 'Ungefähres Datum aus dem bisherigen PAT; das genaue steht nach dem nächsten „eBay neu verbinden“ fest.',
  'status.ebay.reconnectHint': 'Bitte verbinden Sie Ihr eBay-Konto neu, damit Angebote weiter aktualisiert werden.',
  'ebay.connect': 'eBay neu verbinden',
  'ebay.connectFirst': 'eBay verbinden',
  'ebay.connectHint': 'Sie melden sich bei eBay an und erlauben PAT den Zugriff; danach kommen Sie hierher zurück.',
  'ebay.redirecting': 'Sie werden zu eBay weitergeleitet …',
  'ebay.connectOwnerOnly': 'Nur Inhaber können die eBay-Verbindung ändern.',
  'ebay.connectFailed': 'Die Verbindung zu eBay konnte nicht gestartet werden.',
  'ebay.badRedirect': 'Unerwartetes Weiterleitungsziel; der Vorgang wurde abgebrochen.',
  'ebay.return.label': 'eBay-Verbindung',
  'ebay.return.workingTitle': 'Verbindung wird eingerichtet',
  'ebay.return.working': 'Einen Moment bitte – PAT übernimmt Ihre Anmeldung bei eBay.',
  'ebay.return.doneTitle': 'eBay-Konto verbunden',
  'ebay.return.done': 'PAT ist mit Ihrem eBay-Konto „{user}“ verbunden.',
  'ebay.return.doneValid': 'Die Verbindung gilt bis {date}.',
  'ebay.return.doneChanged': 'Das neue eBay-Konto ist verbunden. Angebote und Shopkategorien werden neu eingelesen.',
  'ebay.return.doneRenamed': 'PAT verwendet jetzt den neuen eBay-Namen „{next}“.',
  'ebay.return.doneSwitched': 'PAT ist jetzt mit dem eBay-Konto „{next}“ verbunden.',
  'ebay.return.liveUpdateOff': 'Live-Update ist ausgeschaltet. Schalten Sie es auf der nächsten Seite ein, damit PAT Ihre Angebote einliest und die Galerien in Ihren Beschreibungen aktuell hält.',
  'ebay.return.notQueued':'Der Abgleich der Angebote wird aufgenommen, sobald Ihr Konto dafür freigegeben ist.',
  'ebay.return.pendingTitle': 'Abgleich noch nicht gestartet',
  'ebay.return.pending': 'Die Verbindung ist gespeichert, der Abgleich der Angebote konnte aber noch nicht angestoßen werden.',
  'ebay.return.resume': 'Abgleich jetzt anstoßen',
  'ebay.return.resumed': 'Der Abgleich ist angestoßen.',
  'ebay.return.nothingPending': 'Es stand keine Wiederaufnahme mehr aus.',
  'ebay.resumeOwnerOnly': 'Nur Inhaber können den Abgleich anstoßen.',
  'ebay.return.noSessionTitle': 'Kein laufender Vorgang',
  'ebay.return.noSession': 'In diesem Browserfenster läuft keine Verbindung mit eBay, oder sie ist schon abgeschlossen. Bei Bedarf starten Sie „eBay neu verbinden“ einfach noch einmal.',
  'ebay.return.errorTitle': 'Verbindung nicht gespeichert',
  'ebay.return.errorRetry': 'Sie können die Verbindung gleich noch einmal starten.',
  'ebay.return.confirmTitle': 'Anderes eBay-Konto verwenden?',
  'ebay.return.confirmText': 'Bisher ist „{previous}“ verbunden, jetzt haben Sie sich als „{next}“ angemeldet. Mit „{next}“ liest PAT die Angebote und Shopkategorien neu ein.',
  'ebay.return.confirm': 'Ja, „{next}“ verwenden',
  'ebay.return.renameTitle': 'Neuer eBay-Name?',
  'ebay.return.renameText': 'eBay meldet für Ihr Konto jetzt den Namen „{next}“, bei PAT ist bisher „{previous}“ hinterlegt. Haben Sie Ihr eBay-Konto umbenannt? Dann übernimmt PAT den neuen Namen; Angebote und Einstellungen bleiben erhalten.',
  'ebay.return.renameWrong': 'Ist „{next}“ nicht Ihr bisheriges eBay-Konto, brechen Sie bitte ab.',
  'ebay.return.renameConfirm': 'Ja, Namen „{next}“ übernehmen',
  'ebay.return.switchTitle': 'Anderes eBay-Konto verbinden?',
  'ebay.return.switchLead': 'Sie haben sich bei eBay als „{next}“ angemeldet. Mit PAT verbunden ist bisher „{previous}“.',
  'ebay.return.switchWhat': 'Was beim Wechsel passiert:',
  'ebay.return.switch.account': 'PAT arbeitet künftig mit dem eBay-Konto „{next}“.',
  'ebay.return.switch.liveUpdate': 'Live-Update wird ausgeschaltet. Sobald Sie es wieder einschalten, liest PAT die Angebote und Shopkategorien von „{next}“ ein.',
  'ebay.return.switch.items': 'Angebote von „{previous}“ erscheinen danach nicht mehr; Zuordnungen von Artikeln zu Angeboten beginnen neu.',
  'ebay.return.switch.kept': 'Designs, Artikel und Medien bleiben erhalten.',
  'ebay.return.switch.undo': 'Rückgängig machen lässt sich das nur durch einen erneuten Wechsel.',
  'ebay.return.switchWrong': 'Versehentlich mit dem falschen Konto angemeldet? Dann „Abbrechen“ wählen und bei eBay mit „{previous}“ anmelden.',
  'ebay.return.switchConfirm': 'Ja, zu „{next}“ wechseln',
  'ebay.return.hurry': 'Bitte in den nächsten Minuten bestätigen, sonst verfällt die Anmeldung bei eBay.',
  'ebay.return.abort': 'Abbrechen',
  'ebay.return.toEbay': 'Weiter zu eBay & Live-Update',
  'ebay.declinedTitle': 'Anmeldung bei eBay abgebrochen',
  'ebay.declined': 'Sie haben die Anmeldung bei eBay abgebrochen. Es wurde nichts geändert.',
  'status.sync': 'Abgleich mit eBay',
  'status.sync.paused': 'Pausiert',
  'status.pause.since': '(seit {at})',
  'status.pause.token-invalid': 'Der Abgleich ruht, weil die eBay-Verbindung nicht mehr gültig ist. Bitte oben „eBay neu verbinden“.',
  'status.pause.rate-limit': 'Der Abgleich ruht, weil das eBay-Limit erreicht ist; er setzt automatisch fort.',
  'status.pause.rate-limit.until': 'Der Abgleich ruht, weil das eBay-Limit erreicht ist; er setzt ab {at} automatisch fort.',
  'status.pause.manual': 'Der Abgleich wurde manuell angehalten.',
  'status.pause.lift': 'Pause aufheben',
  'status.pause.ownerOnly': 'Aufheben kann nur der Inhaber des Kontos.',
  'status.pause.migration': 'Bis zum Abschluss des Umzugs bleibt die Pause bestehen.',
  'status.counts.active': 'Aktive Angebote',
  'status.counts.errors': 'Angebote mit Update-Fehlern',
  'status.counts.pending': 'Wartende Aktualisierungen',
  'status.counts.asOf': 'Stand: {date}',
  'status.cancelScheduled': 'Ihr Konto ist zum {date} gekündigt.',
  'status.openInvoices.one': 'Es gibt noch {count} offene Rechnung in Ihrem Konto.',
  'status.openInvoices.other': 'Es gibt noch {count} offene Rechnungen in Ihrem Konto.',
  'status.openInvoices.link': 'Zu den Rechnungen',
  'status.job.type': 'Auftrag',
  'status.job.state': 'Zustand',
  'status.job.lastSuccess': 'Zuletzt erfolgreich',
  'status.job.next': 'Nächster Lauf',
  'status.job.error': 'Letzter Fehler',
  'status.job.none': 'Noch keine Aufträge gelaufen.',
  'job.sync.reconcile': 'Vollständiger Abgleich',
  'job.sync.delta': 'Änderungen holen',
  'job.item.details': 'Angebotsdetails',
  'job.store.sync': 'Shopkategorien',
  'status.storeRefresh.request': 'Aktualisierung vormerken',
  'status.storeRefresh.pending': 'Vorgemerkt – der Zeitplan übernimmt den Abgleich.',
  'status.storeRefresh.unavailable': 'Live-Update aktivieren und die eBay-Verbindung prüfen.',
  'status.storeRefresh.error': 'Vormerkung nicht sicher möglich. Bitte den Status neu laden.',
  'job.rules.evaluate': 'Cross-Selling-Regeln',
  'job.description.reconcile': 'Beschreibungen prüfen',
  'job.description.revise': 'Beschreibung aktualisieren',
  'job.token.check': 'Token prüfen',
  'job.tenant.import': 'Kontoimport',
  'job.account.followup': 'Kontodaten-Nachlauf',
  // Zähler des letzten Laufs (apps/sync: description.reconcile, description.revise, rules.evaluate).
  'job.counter.scanned': 'geprüft',
  'job.counter.changed': 'geändert',
  'job.counter.pages': 'Seiten',
  'job.counter.processed': 'verarbeitet',
  'job.counter.steps': 'Schritte',
  'job.counter.storeSubscribed': 'Shop-Abo',
  'job.counter.categories': 'Kategorien',
  'job.counter.superseded': 'überholt',
  // Kontodaten-Nachlauf (`account.followup`, core 25.10.2026): verschwundene Quellzeilen bleiben stehen und werden nur
  // gezählt; Gründe wie `INVOICE_SKIP_REASONS` im Importplaner.
  'job.counter.missing-in-source': 'in der Quelle nicht mehr vorhanden',
  'job.counter.invoices-new': 'neue Rechnungen',
  'job.counter.invoices-changed': 'geänderte Rechnungen',
  'job.counter.skipped-id-invalid': 'übersprungen (ID ungültig)',
  'job.counter.skipped-number-missing': 'übersprungen (ohne Nummer)',
  'job.counter.skipped-number-invalid': 'übersprungen (Nummer ungültig)',
  'job.counter.skipped-number-duplicate': 'übersprungen (Nummer doppelt)',
  'job.counter.skipped-status-unknown': 'übersprungen (Status unbekannt)',
  'job.counter.skipped-issued-invalid': 'übersprungen (Datum ungültig)',
  'job.counter.managed': 'verwaltet',
  'job.counter.evaluated': 'ausgewertet',
  'job.counter.queued': 'vorgemerkt',
  'job.counter.unchanged': 'unverändert',
  'job.counter.deferred': 'zurückgestellt',
  'job.counter.blocked': 'gesperrt',
  'job.counter.locked': 'Regeln gesperrt',
  'job.counter.inspected': 'geprüft',
  'job.counter.written': 'geschrieben',
  'job.counter.alreadyDesired': 'schon aktuell',
  'job.counter.failed': 'fehlgeschlagen',
  'job.counter.writeOutcomeUnknown': 'Ausgang unklar',
  // Fehlercodes der Beschreibungs-Worker (apps/sync description*.ts); unbekannte erscheinen roh.
  'job.error.description-policy-blocked': 'Konto oder Einstellungen lassen gerade keine Aktualisierung zu.',
  'job.error.description-candidates-blocked': 'Einige Angebote sind gesperrt (Konto, Verbindung oder Galerie).',
  'job.error.ebay-auth': 'Die eBay-Verbindung fehlt oder ist abgelaufen.',
  'job.error.description-writes-disabled': 'Die Übertragung an eBay ist in dieser Umgebung nicht aktiv.',
  'job.error.description-budget': 'Das Tageskontingent für Aktualisierungen ist erreicht.',
  'job.error.snapshot-conflict': 'Die Daten haben sich während des Laufs geändert; der nächste Lauf holt es nach.',
  'job.error.followup-incomplete': 'Nachlauf unvollständig: Ein Teil der Rechnungen wurde nicht übernommen; der nächste Lauf holt es nach.',
  'job.error.write-outcome-unknown': 'Ob eBay die Aktualisierung übernommen hat, ist unklar; sie wird geprüft.',
  // Endzustände eines Auftrags je Angebot (Codex-1, description-order-*): der Auftrag wurde nicht ausgeführt.
  'job.error.article-changed': 'Ein Auftrag je Angebot wurde nicht ausgeführt: Der Artikel ist inzwischen neu veröffentlicht; bitte beim Artikel neu beauftragen.',
  'job.error.source-missing': 'Ein Auftrag je Angebot wurde nicht ausgeführt: Das Angebot ist dem Artikel nicht mehr zugeordnet oder fehlt.',
  'job.error.description-source-missing': 'Ein Auftrag je Angebot wurde nicht ausgeführt: Das Angebot ist dem Artikel nicht mehr zugeordnet oder fehlt.',
  'jobState.idle': 'bereit',
  'jobState.running': 'läuft',
  'jobState.failed': 'Fehler',
  'jobState.paused': 'pausiert',
  'items.title': 'Angebote',
  'items.search': 'Suche nach Titel, SKU oder Angebotsnummer',
  'items.status': 'Status',
  'items.status.active': 'Aktiv',
  'items.status.ended': 'Beendet',
  'items.status.all': 'Alle',
  'items.site': 'eBay-Site',
  'items.site.all': 'Alle Sites',
  'items.type': 'Angebotsart',
  'items.type.all': 'Alle Arten',
  'items.type.auction': 'Auktion',
  'items.type.fixed': 'Festpreis',
  'items.type.store': 'Shop',
  'items.type.other': 'Sonstige',
  'items.assigned': 'Artikelbeschreibung',
  'items.assigned.all': 'Alle',
  'items.assigned.yes': 'Zugeordnet',
  'items.assigned.no': 'Nicht zugeordnet',
  'items.col.item': 'Angebot',
  'items.col.price': 'Preis',
  'items.col.quantity': 'Verfügbar',
  'items.col.end': 'Ende',
  'items.col.article': 'Beschreibung',
  'items.variations': 'Varianten',
  'items.ended': 'beendet',
  'items.state.scheduled': 'geplant',
  'items.state.soldout': 'ausverkauft',
  'items.state.ended': 'beendet',
  'embed.unknown': 'unbekannt',
  'embed.in-sync': 'aktuell',
  'embed.pending': 'wartet',
  'embed.revising': 'wird aktualisiert',
  'embed.failed': 'Update-Fehler',
  'embed.blocked': 'angehalten',
  'embed.diverged': 'bei eBay geändert',
  'embed.warnings': '{n} Hinweis(e)',
  'itemPreview.open': 'Vorschau',
  'itemPreview.title': 'Vorschau der Beschreibung',
  'itemPreview.stored': 'Gespeicherte Sollfassung aus Artikel-Fassung {article} und Design-Fassung {design} (Stand {date}). Das ist nicht die aktuelle Beschreibung bei eBay.',
  'liveBlockPreview.open': 'Live-Vorschau',
  'liveBlockPreview.title': 'Live-Vorschau der Galerieblöcke',
  'liveBlockPreview.intro': 'PAT liest die aktuelle Beschreibung dieses Angebots einmal bei eBay und zeigt, wie sie mit aktuellen Galerieblöcken aussähe. Bei eBay wird dabei nichts geändert.',
  'liveBlockPreview.quota': 'Jede Live-Vorschau zählt als ein Lesezugriff gegen das Tageskontingent Ihres Kontos, das auch der automatische Abgleich nutzt.',
  'liveBlockPreview.load': 'Live-Vorschau laden',
  'liveBlockPreview.result': 'Aktuelle Beschreibung bei eBay mit den Galerieblöcken, wie PAT sie austauschen würde (PAT-Daten vom {date}). Bei eBay wurde nichts geändert.',
  'liveBlockPreview.noBlocks': 'In der Beschreibung bei eBay steht kein PAT-Galerieblock; ein Live-Update würde nichts ändern.',
  'liveBlockPreview.unchanged': 'Die Galerieblöcke bei eBay sind bereits aktuell ({count} gefunden).',
  'liveBlockPreview.changed': 'Ein Live-Update würde die Galerieblöcke so ändern ({count} gefunden).',
  'liveBlockPreview.section': 'Live-Vorschau je Angebot',
  'liveBlockPreview.sectionIntro': 'Für Angebote, in deren Beschreibung PAT Galerieblöcke pflegt: Angebotsnummer eingeben und die Beschreibung mit aktuellen Blöcken ansehen.',
  'liveBlockPreview.itemId': 'Angebotsnummer',
  'liveBlockPreview.itemIdInvalid': 'Bitte eine eBay-Angebotsnummer aus Ziffern eingeben',
  'liveBlockPreview.editorsOnly': 'Die Live-Vorschau können Bearbeiter und Inhaber öffnen.',
  'backups.open': 'Sicherungen',
  'backups.title': 'Sicherungen der Beschreibung',
  'backups.intro': 'Vor jedem Schreibversuch sichert PAT die bisherige Beschreibung bei eBay. Anlass und Umfang beschreiben den vorgesehenen Schreibvorgang; ob eBay ihn angenommen hat, zeigt der Zustand des Angebots. Zurückspielen ist noch nicht möglich.',
  'backups.none': 'Für dieses Angebot gibt es noch keine Sicherung.',
  'backups.more': 'Gezeigt werden die neuesten {shown} von {total} Sicherungen.',
  'backups.col.at': 'Gesichert',
  'backups.col.size': 'Größe',
  'backups.col.reason': 'Anlass',
  'backups.col.mode': 'Vorgesehen',
  'backups.size': '{kb} KB',
  'backups.reason.customer-ordered': 'Auftrag je Angebot',
  'backups.reason.user': 'Überschreiben auf Auftrag',
  'backups.reason.gallery-deleted': 'Galerie gelöscht',
  'backups.reason.gallery-changed': 'Galerie geändert',
  'backups.reason.rules-changed': 'Regeln geändert',
  'backups.reason.selection-changed': 'Galerieauswahl aktualisiert',
  'backups.reason.assigned': 'Angebot zugeordnet',
  'backups.reason.marker-detected': 'Galerie erkannt',
  'backups.reason.article-published': 'Artikel veröffentlicht',
  'backups.reason.design-published': 'Design veröffentlicht',
  'backups.reason.other': 'sonstiger Anlass',
  'backups.mode.full': 'ganze Beschreibung',
  'backups.mode.block': 'Galerieblock',
  'backups.mode.insert': 'eingefügte Galerie',
  'embed.error.article-changed': 'Artikel inzwischen neu veröffentlicht; bitte neu beauftragen.',
  'embed.error.article-changed.items': 'Auftrag nicht ausgeführt: Artikel inzwischen neu veröffentlicht; beim Artikel neu beauftragen.',
  'embed.error.source-missing': 'Letzter Auftrag nicht ausgeführt: Das Angebot war dem Artikel zwischenzeitlich nicht zugeordnet; bitte neu beauftragen.',
  'embed.error.source-missing.items': 'Auftrag nicht ausgeführt: Das Angebot war dem Artikel nicht (mehr) zugeordnet.',
  'articles.items.written': 'Ersetzt am {date} (Fassung {version}).',
  'articles.items.written-inspected': 'Ersetzt (Fassung {version}), bestätigt durch Nachprüfung bei eBay am {date}.',
  'articles.items.already-current': 'Geprüft am {date}: war bereits Fassung {version}, nichts geschrieben.',
  'items.more': 'Weitere laden',
  'items.empty': 'Keine Angebote gefunden.',
  'items.order.endTime': 'Sortiert nach Ende',
  'items.order.itemId': 'Sortiert nach Angebotsnummer',
  'items.openOnEbay': 'Auf eBay öffnen',
  'items.overwrite.open': 'Trotzdem überschreiben',
  'items.overwrite.title': 'Diese Beschreibung trotzdem überschreiben?',
  'items.overwrite.text': 'Die Beschreibung dieses Angebots wurde direkt bei eBay geändert, zum Beispiel von Hand oder über „Ähnlichen Artikel verkaufen“. PAT hat sie deshalb seit {date} nicht mehr aktualisiert.',
  'items.overwrite.warning': 'Beim Überschreiben ersetzt PAT sie durch die aktuelle PAT-Beschreibung. Die Änderungen bei eBay gehen dabei verloren.',
  'items.overwrite.confirm': 'Jetzt überschreiben',
  'items.overwrite.done': 'Überschreiben ist vorgemerkt',
  'items.overwrite.failed': 'Überschreiben konnte nicht vorgemerkt werden.',
} as const;

export type TextKey = keyof typeof TEXTS;

export function t(key: TextKey, vars?: Record<string, string | number>): string {
  return TEXTS[key].replace(/\{(\w+)\}/g, (_, name: string) => String(vars?.[name] ?? ''));
}

/** Prüft, ob ein dynamischer Schlüssel existiert (z. B. aus Jobtypen). */
export function has(key: string): key is TextKey {
  return key in TEXTS;
}

// Zeitpunkte in der Geschäftszone (wie eBay.de und das Altsystem), unabhängig von der Zeitzone des Browsers oder Testrunners.
const dateFormat = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Berlin' });
const dayFormat = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium', timeZone: 'Europe/Berlin' });
/** Letzter Tag vor einer exklusiven Grenze, in der Geschäftszone wie core `endOfLegacyDay`. */
const cutoffFormat = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium', timeZone: 'Europe/Berlin' });
const numberFormat = new Intl.NumberFormat('de-DE');

export function dateTime(iso: string | undefined): string {
  return iso ? dateFormat.format(new Date(iso)) : TEXTS['common.unknown'];
}

/** Nur das Datum (Geschäftszone), z. B. „Mitglied seit“. */
export function dateOnly(iso: string | undefined): string {
  return iso ? dayFormat.format(new Date(iso)) : TEXTS['common.unknown'];
}

/**
 * „Kündigung zum“: `cancelEffectiveAt` ist laut core die exklusive Grenze 00:00 Europe/Berlin des Folgetags nach
 * `user_last_bill` (`endOfLegacyDay`). Angezeigt wird der letzte Tag davor in Europe/Berlin, unabhängig von der
 * Zeitzone des Browsers: `2026-12-31T23:00:00Z` → 31.12.2026.
 */
export function cutoffDate(iso: string | undefined): string {
  return iso ? cutoffFormat.format(new Date(Date.parse(iso) - 1)) : TEXTS['common.unknown'];
}

/**
 * Kalendertag `YYYY-MM-DD` (core `IsoDate`, z. B. Rechnungsdatum) ohne Zeitzonenverschiebung: als UTC-Mitternacht
 * gelesen und in UTC formatiert wie `cutoffDate`. Ungültige Tage bleiben roh stehen; der Rundweg fängt auch Tage, die
 * V8 weiterrechnet (`2026-02-30` → 02.03.), denn core `IsoDate` prüft nur das Muster.
 */
export function calendarDate(day: string | undefined): string {
  if (!day) return TEXTS['common.unknown'];
  const date = new Date(`${day}T00:00:00Z`);
  return Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== day ? day : cutoffFormat.format(date);
}

export function count(value: number): string {
  return numberFormat.format(value);
}

export function money(amount: string, currency: string): string {
  const value = Number(amount);
  if (!Number.isFinite(value)) return `${amount} ${currency}`;
  try {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(value);
  } catch {
    return `${amount} ${currency}`;
  }
}
